
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useDateRangePickerState } from './hooks/useDateRangePickerState';
import { DateRangeInputs } from './components/DateRangeInputs';
import { MantineCalendar } from './components/MantineCalendar';
import { MantineProvider } from './MantineProvider';
import { DateChangeHandler, createNoOpDateChangeHandler } from './utils/datePickerUtils';

interface MantineDateRangePickerProps {
  form: UseFormReturn<any>;
  startDateName: string;
  endDateName: string;
  startDateLabel?: string;
  endDateLabel?: string;
  onDateChange?: DateChangeHandler;
}

export const MantineDateRangePicker: React.FC<MantineDateRangePickerProps> = ({
  form,
  startDateName,
  endDateName,
  startDateLabel = "Start date",
  endDateLabel = "End date",
  onDateChange = createNoOpDateChangeHandler()
}) => {
  const {
    startDate,
    endDate,
    startInputValue,
    endInputValue,
    handleDateClick,
    handleStartDateInputChange,
    handleEndDateInputChange,
    handleStartDateBlur,
    handleEndDateBlur
  } = useDateRangePickerState({
    form,
    startDateName,
    endDateName,
    onDateChange
  });

  return (
    <div className="space-y-4">
      <DateRangeInputs
        form={form}
        startDateName={startDateName}
        endDateName={endDateName}
        startDateLabel={startDateLabel}
        endDateLabel={endDateLabel}
        startInputValue={startInputValue}
        endInputValue={endInputValue}
        handleStartDateInputChange={handleStartDateInputChange}
        handleEndDateInputChange={handleEndDateInputChange}
        handleStartDateBlur={handleStartDateBlur}
        handleEndDateBlur={handleEndDateBlur}
      />
      
      <MantineProvider>
        <MantineCalendar
          startDate={startDate}
          endDate={endDate}
          handleDateClick={handleDateClick}
        />
      </MantineProvider>
    </div>
  );
};
